export default function ThinkingSteps({ steps }) {
  if (!steps || steps.length === 0) return null;
  return (
    <div className="flex flex-col gap-1.5 mb-2 text-xs text-gray-700">
      {steps.map((s, i) => (
        <div key={i} className="flex items-center gap-2 px-3 py-1.5 bg-white/20 backdrop-blur-md rounded-full border border-white/30 shadow-sm">
          <span>{s.content}</span>
        </div>
      ))}
    </div>
  );
}